import { useFormikContext } from "formik";
import { PlateformeFormFieldNames } from "../form/PlateformeFormFieldNames";
import { PlateformeFormValues } from "../form/PlateformeFormValues";

interface TypeCompagnieOption {
  /** Sous-nature envoyée au back ('' = compagnie, variant par défaut). */
  value: string;
  label: string;
  description: string;
}

const TYPE_COMPAGNIE_OPTIONS: TypeCompagnieOption[] = [
  {
    value: '',
    label: "Compagnie d'assurance",
    description: 'Société d’assurance régie par le Code des assurances.',
  },
  {
    value: 'MUT',
    label: 'Mutuelle',
    description: 'Organisme régi par le Code de la mutualité.',
  },
  {
    value: 'REA',
    label: 'Réassureur',
    description: 'Porteur de risque en réassurance.',
  },
];

/**
 * Type de compagnie = sous-nature de la PM corporate créée avec la plateforme.
 * Identité (badge, filtres, kit des futurs membres) — les droits restent ceux
 * du profil Compagnie quel que soit le variant.
 */
export const TypeCompagnieField: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<PlateformeFormValues>();
  const selected = values[PlateformeFormFieldNames.SousNature] ?? '';

  return (
    <div className="mb-4">
      <span className="mb-2 block text-sm font-medium text-gray-700">Type de compagnie</span>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {TYPE_COMPAGNIE_OPTIONS.map((option) => (
          <label
            key={option.value || 'CIE'}
            className={`flex items-start gap-3 rounded-xl border bg-white p-3 cursor-pointer shadow-sm transition-colors ${
              selected === option.value
                ? 'border-primary ring-1 ring-primary/30'
                : 'border-gray-200 hover:border-primary/40'
            }`}
          >
            <input
              type="radio"
              name={PlateformeFormFieldNames.SousNature}
              checked={selected === option.value}
              onChange={() => setFieldValue(PlateformeFormFieldNames.SousNature, option.value)}
              className="mt-0.5 h-4 w-4 border-gray-300 text-primary focus:ring-primary"
            />
            <span className="flex flex-col gap-0.5">
              <span className="text-sm font-semibold text-gray-900">{option.label}</span>
              <span className="text-xs text-gray-500 leading-relaxed">{option.description}</span>
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};
